export default __webpack_public_path__ + "static/media/unseen_filter.3e55173b.png";